import { action } from 'typesafe-actions'
import { SEARCH_ASSETS, SET_ASSETS_RESULTS, SET_IS_SEARCHING } from './constants'

export const searchAssets = (query: any) => action(SEARCH_ASSETS, query)
export const setAssetsResults = (searchAsset: any) => action(SET_ASSETS_RESULTS, searchAsset)

export const setIsSearching = (isSearching: any) => action(SET_IS_SEARCHING, isSearching)
